import { EvokeAction } from "react-evoke";
import { AppState } from "../../typings/AppState";
import { AppActions } from "../../typings/AppActions";
import { api } from "../../api";

const getDepartmentChart: EvokeAction<AppState, AppActions> = async store => {
  try {
    const departmentsChart = await api.get(`home/department`);
    await store.update(state => {
      state.departmentsChart = departmentsChart;
    });
  } catch (error) {
    console.log("error", error);
  }
};

const getWeeklySales: EvokeAction<AppState, AppActions> = async store => {
  try {
    const weeklySales = await api.get(`home/weeklysales`);
    await store.update(state => {
      state.weeklySales = weeklySales;
    });
  } catch (error) {
    console.log("error", error);
  }
};

const getSalesReportData: EvokeAction<AppState, AppActions> = async store => {
  try {
    const salesReportData = await api.get(`home/sales`);
    await store.update(state => {
      state.salesReportData = salesReportData;
    });
  } catch (error) {
    console.log("error", error);
  }
};

const getDailyReportData: EvokeAction<AppState, AppActions> = async store => {
  try {
    const dailySales = await api.get(`home/dailysales`);
    await store.update(state => {
      state.dailySales = dailySales;
    });
  } catch (error) {
    console.log("error", error);
  }
};

export const homeActions = {
    getDepartmentChart,
    getWeeklySales,
    getSalesReportData,
    getDailyReportData
};